import moment from 'moment';

export const timeFormatLongAmPm = 'h:mm:ss A';
const FP_WEAR_TIME_LOG = 'FP_WEAR_TIME_LOG';

export const getHourForUtc = () => {
  const offsetInSeconds = moment().utcOffset();
  const inHour = `${moment('1900-01-01 00:00:00')
    .add(Math.abs(offsetInSeconds), 'seconds')
    .format('mm:ss')}`; // for getting the difference from the duration
  if (offsetInSeconds < 0) return `UTC-${inHour}`;
  return `UTC+${inHour}`;
};

export const formatTime = (hours, minutes, seconds) => {
  const formattedHour = hours < 10 ? `0${hours}` : `${hours}`;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const formattesSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
  return {
    hours: formattedHour,
    minutes: formattedMinutes,
    seconds: formattesSeconds
  };
};

export const formatNumberToTime = (number) => {
  const secNum = Number(number);
  const hours = Math.floor(secNum / 3600);
  const minutes = Math.floor((secNum - hours * 3600) / 60);
  const seconds = secNum - hours * 3600 - minutes * 60;
  return formatTime(hours, minutes, seconds);
};

export const TIMER_STATUSES = {
  PLAY: 'PLAY',
  PAUSE: 'PAUSE'
};

export const WEAR_TIME_EDIT_OPTIONS = {
  ADD: 'ADD',
  MINUS: 'MINUS',
  CUSTOM: 'CUSTOM'
};

export const getCurrentUtcTimestamp = (date = moment()) => (
  moment(date).format('YYYY-MM-DD')
);

export const isWearTimeFeatureEnabled = (
  featureStatusResponse
) => !!featureStatusResponse?.plugins?.includes?.(FP_WEAR_TIME_LOG);

export const getDaysDiff = (start, date) => {
  const diff = moment(date).startOf('day').diff(moment(start).startOf('day'), 'days') + 1;
  if (diff > 7) return 7;
  return diff;
};
